import { alertFilterApi } from '../../apis';
import { Dispatch } from 'redux';
import {
  addNewAlertFilterSuccess,
  deleteAlertFilterSuccess,
  fetchAlertFiltersSuccess,
  setLoadingAlertFilters,
  updateAlertFilterSuccess,
} from './alertFiltersReducer';
import { parseErrorMessage } from '../../common/errors/helpers';
import { showFeedback } from '../../feedback/feedbackReducer';
import { InternalApiAlertFilterExpression, InternalApiRole } from '../../api-internal';

const dispatchError = async (dispatch: Dispatch, error: unknown): Promise<void> => {
  const message = await parseErrorMessage(error);
  dispatch(
    showFeedback({
      message,
      success: false,
    })
  );
};

export const fetchAlertFilters = () => async (dispatch: Dispatch) => {
  dispatch(setLoadingAlertFilters(true));
  try {
    const filters = await alertFilterApi.findAlertFilters();
    dispatch(fetchAlertFiltersSuccess(filters));
  } catch (e: unknown) {
    await dispatchError(dispatch, e);
  } finally {
    dispatch(setLoadingAlertFilters(false));
  }
};

export const addNewAlertFilter =
  (name: string, expressions: Array<InternalApiAlertFilterExpression>, roles: Array<InternalApiRole>) =>
  async (dispatch: Dispatch) => {
    try {
      const filter = await alertFilterApi.addAlertFilter({
        internalApiNewAlertFilter: {
          name,
          expressions,
          roles,
        },
      });
      dispatch(addNewAlertFilterSuccess(filter));
    } catch (e: unknown) {
      await dispatchError(dispatch, e);
    }
  };

export const updateAlertFilter =
  (id: number, name: string, expressions: Array<InternalApiAlertFilterExpression>, roles: Array<InternalApiRole>) =>
  async (dispatch: Dispatch) => {
    try {
      const filter = await alertFilterApi.updateAlertFilter({
        id,
        internalApiNewAlertFilter: {
          name,
          expressions,
          roles,
        },
      });
      dispatch(updateAlertFilterSuccess(filter));
    } catch (e: unknown) {
      await dispatchError(dispatch, e);
    }
  };

export const deleteAlertFilter = (id: number) => async (dispatch: Dispatch) => {
  try {
    await alertFilterApi.deleteAlertFilter({ id });
    dispatch(deleteAlertFilterSuccess(id));
  } catch (e: unknown) {
    await dispatchError(dispatch, e);
  }
};
